export const CACHE_CATEGORY = "FLFCategory";
export const CACHE_IOT_PARTNER = "FLFIotPartner";
export const CACHE_ROGO_DEV_TYPE = "FLFRogoDevType";
export const CACHE_ROGO_DEV_SUB_TYPE = "FLFRogoDevSubType";
export const CACHE_QUERY_TYPE = "FLFQueryType";
export const CACHE_HOME_INDEX = "FLFHomeIndex";
export const CACHE_NOTIFY_CONFIG = "FLFNotifyConfig";
export const CACHE_PAIRING_TYPE = "FLFPairingType";
export const CACHE_ICON = "FLFIcon";
export const CACHE_DEVICE = "FLFDevice";
export const CACHE_CUSTOMER = "FLFCustomer";
export const CACHE_CONTEXT = "FLFContext";
export const CACHE_CONTEXT_DEVICE = "FLFContextDevice";
export const CACHE_ADB = "ADB";
export const CACHE_PROVINCE = "ADBProvince";
export const CACHE_DISTRICT = "ADBDistrict";
export const CACHE_WARD = "ADBWard";
export const CACHE_RELEASE_APP_OS = "ReleaseAppOS";
export const CACHE_RELEASE_TYPE_SPEAKER = "ReleaseTypeSpeaker";
export const CACHE_RELEASE_GROUP = "ReleaseGroup";
export const CACHE_RELEASE_APP_VERSION = "ReleaseAppVersion";
export const CACHE_RELEASE_SPEAKER_VERSION = "ReleaseSpeakerVersion";
